module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__restaurant-3a7ffd8c65eeffb42b89270e8c699c14.svg";